<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <div class="error-message">抱歉，您访问的页面不存在</div>
      <el-button type="primary" @click="goHome">返回首页</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="less" scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: @bg-color;
}

.not-found-content {
  text-align: center;

  .error-code {
    font-size: 120px;
    font-weight: 700;
    color: @primary-color;
    line-height: 1;
    margin-bottom: 16px;
    text-shadow: 2px 4px 8px rgba(64, 158, 255, 0.3);
  }

  .error-message {
    font-size: 18px;
    color: @text-secondary;
    margin-bottom: 30px;
  }
}
</style>
